import React from "react";
import Home from "../pages/Home";
import Project from "../pages/Project";
import Setup from "../pages/Setup";
import Landing from "../pages/Landing";
import Queues from "../pages/Queues";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/bpm",
            component: (
                <Landing history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/bpm/queues",
            component: (
                <Queues history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/bpm/queues/availablequeues",
            component: (
                <Home history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/bpm/queues/:id",
            component: (
                <Project history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/bpm/setup",
            component: (
                <Setup history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
    ]
};

export default routes;